import { render, staticRenderFns } from "./EmotionList.vue?vue&type=template&id=66c2f584&scoped=true&"
import script from "./EmotionList.vue?vue&type=script&lang=js&"
export * from "./EmotionList.vue?vue&type=script&lang=js&"
import style0 from "./EmotionList.vue?vue&type=style&index=0&id=66c2f584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2f584",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSimpleTable,VSkeletonLoader})
